import React, { useState, useEffect } from 'react';
import Logo from 'components/common/Logo';
import { Col, Dropdown, Nav, Navbar, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import NotificationDropdownMenu from '../nav-items/NotificationDropdownMenu';
import ProfileDropdownMenu from '../nav-items/ProfileDropdownMenu';
import SearchBox from 'components/common/SearchBox';
import ThemeToggler from 'components/common/ThemeToggler';

const EcommerceTopbar = () => {
  const [totalCartItems, setTotalCartItems] = useState(0);

  const getTotalCartItems = () => {
    const cart = JSON.parse(localStorage.getItem('cart') || '[]');
    return cart.reduce((total: number, item: { quantity: number }) => total + item.quantity, 0);
  };

  useEffect(() => {
    const updateCartItems = () => {
      setTotalCartItems(getTotalCartItems());
    };

    // Atualiza o total de itens no carrinho ao montar o componente
    updateCartItems();

    // Adiciona event listeners para monitorar mudanças no localStorage e o evento personalizado
    window.addEventListener('storage', updateCartItems);
    window.addEventListener('cartUpdated', updateCartItems);

    // Limpa os event listeners ao desmontar o componente
    return () => {
      window.removeEventListener('storage', updateCartItems);
      window.removeEventListener('cartUpdated', updateCartItems);
    };
  }, []);

  return (
    <div className="container-small">
      <div className="ecommerce-topbar">
        <Navbar className="px-0" >
          <Row className="gx-0 gy-2 w-100 flex-between-center">
            <Col xs="auto">
              <Link to="/shop" className="text-decoration-none">
                <Logo />
              </Link>
            </Col>
            <Col xs="auto" className="order-md-1">
              <Nav as="ul" className="navbar-nav-icons flex-row me-n2">
                <Nav.Item as="li" className="d-flex align-items-center">
                  <ThemeToggler />
                </Nav.Item>

                <Nav.Item as="li">
                  <Nav.Link
                    as={Link}
                    to="/shop/cart"
                    className="px-2 icon-indicator icon-indicator-primary"
                  >
                    <FeatherIcon icon="shopping-cart" size={20} />
                    <span className="icon-indicator-number">{totalCartItems}</span>
                  </Nav.Link>
                </Nav.Item>

               {/*  <Nav.Item as="li">
                  <Dropdown autoClose="outside">
                    <Dropdown.Toggle
                      as={Link}
                      to="#!"
                      className="dropdown-caret-none nav-link icon-indicator icon-indicator-sm icon-indicator-danger"
                      variant=""
                    >
                      <FeatherIcon icon="bell" size={20} />
                    </Dropdown.Toggle>
                    <NotificationDropdownMenu className="mt-2" />
                  </Dropdown>
                </Nav.Item> */}

                <Nav.Item as="li">
                  <Dropdown autoClose="outside">
                    <Dropdown.Toggle
                      as={Link}
                      to="#!"
                      className="dropdown-caret-none nav-link lh-1"
                      variant=""
                    >
                      <FeatherIcon icon="user" size={20} />
                    </Dropdown.Toggle>
                    <ProfileDropdownMenu className="mt-2" />
                  </Dropdown>
                </Nav.Item>
              </Nav>
            </Col>
            <Col xs={12} md={6}>
              {/* <SearchBox
                placeholder="Search..."
                className="ecommerce-search-box w-100"
                inputClassName="rounded-pill"
                size="sm"
                // style={{ width: '25rem' }}
              /> */}
            </Col>
          </Row>
        </Navbar>
      </div>
    </div>
  );
};

export default EcommerceTopbar;
